import type { Trip } from "@/api.types.v2";

type Progress = Partial<
  Pick<
    Trip,
    | "totalTasks"
    | "pendingTasks"
    | "inProgressTasks"
    | "completedTasks"
    | "failedTasks"
    | "cancelledTasks"
  >
>;

export function TripProgress({ progress }: { progress?: Progress }) {
  const counts = [
    ["pending", progress?.pendingTasks],
    ["in progress", progress?.inProgressTasks],
    ["completed", progress?.completedTasks],
    ["failed", progress?.failedTasks],
    ["cancelled", progress?.cancelledTasks],
  ] as const;
  return (
    <div>
      <span>
        {progress?.totalTasks === undefined
          ? "Task total unavailable"
          : `${progress.totalTasks} tasks`}
      </span>
      <span className="block text-xs text-muted-foreground">
        {counts.some(([, count]) => count === undefined)
          ? "Task progress unavailable"
          : counts.map(([label, count]) => `${count} ${label}`).join(" · ")}
      </span>
    </div>
  );
}
